
import { mapState } from 'vuex'
export default {
  inject: ['detail'],
  data() {
    return {
      widthType : 'pc'
    }
  },
  computed: {
    ...mapState({
      isMobile: 'mobile',
      contentcookie: 'contentcookie'
    })
  },
  mounted() {
    console.log('detail-userinfo')
    this.getelewidth()
  },
  methods: {
    getelewidth() {
      const ele = document.documentElement.clientWidth
      if (ele >= 1199 - this.getScrollbarWidth())
        this.widthType =  'pc'
      else if (ele >= 999 - this.getScrollbarWidth() && ele < 1199 - this.getScrollbarWidth())
        this.widthType =  'lg'
      else if (ele >= 799 - this.getScrollbarWidth() && ele < 999 - this.getScrollbarWidth())
        this.widthType =  'md'
      else this.widthType =  'sm'
    },
    getScrollbarWidth() {
      // 计算滚动条宽度
      const scrollDiv = document.createElement('div')
      scrollDiv.style.cssText = 'height: 99px; overflow: scroll; position: absolute; top: -9999px;'
      document.body.appendChild(scrollDiv)
      const scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth
      document.body.removeChild(scrollDiv)
      return scrollbarWidth
    }
  }
}
